var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistNotReportedSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.442,
    height: 13.172,
    viewBox: "0 0 12.442 13.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_131",
    "data-name": "Shape 131",
    d: "M652.141,4008.152a.257.257,0,0,1,.384,0l4.743,5.1,4.642-4.989a.259.259,0,0,1,.384,0,.308.308,0,0,1,0,.413l-4.642,4.988,4.622,4.969a.309.309,0,0,1,0,.414.259.259,0,0,1-.384,0l-4.622-4.969-4.724,5.077a.258.258,0,0,1-.384,0,.307.307,0,0,1,0-.413l4.723-5.078-4.743-5.1A.306.306,0,0,1,652.141,4008.152Z",
    transform: "translate(-650.997 -4007.066)",
    fill: "none",
    stroke: "#e3401d",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistNotReportedSmall);
export default __webpack_public_path__ + "static/media/ChecklistNotReportedSmall.f82ade33a4bb880ac23e2d67609fa0b5.svg";
export { ForwardRef as ReactComponent };